import { groupBy } from './helpers'
import { getLocaleEndonym } from './locale'
import type { Course } from '@/domain/entities/course.entity'

export interface CourseLocaleGroup {
    locale: string | null
    localeLabel: string
    courses: Course[]
}

/**
 * Группирует курсы по локалям
 * @param courses - массив курсов
 * @param getUnknownLocaleLabel - функция для получения метки неизвестной локали (опционально)
 * @returns массив групп курсов с метаданными о локали
 */
export function groupCoursesByLocale(
    courses: Course[],
    getUnknownLocaleLabel?: () => string
): CourseLocaleGroup[] {
    if (!courses || courses.length === 0) {
        return []
    }

    // Используем общую функцию группировки
    const groups = groupBy(courses, (course) => course.locale || 'unknown')

    // Преобразуем в массив с метаданными
    const result: CourseLocaleGroup[] = []

    for (const [localeKey, courses] of groups.entries()) {
        const locale = localeKey === 'unknown' ? null : String(localeKey)
        const localeLabel = locale === null
            ? (getUnknownLocaleLabel ? getUnknownLocaleLabel() : 'Інші мови')
            : getLocaleEndonym(locale)

        result.push({
            locale,
            localeLabel,
            courses,
        })
    }
    return result
}
